import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  ColumnDef,
  flexRender,
  SortingState,
  RowSelectionState
} from "@tanstack/react-table";
import { Image  } from "react-bootstrap";
// import styles from './SponseredUsersTable.module.css';
import cn from 'classnames';
import { useEffect, useMemo, useState } from "react";
import UserCard from "../../../../../component/common/UserCard/UserCard";
import ActionButtons from "../../../../../component/UI/ActionButtons/ActionButtons";
import { ASSESTS } from "../../../../../constant/assest";
import Pagination from "../../../../../component/UI/Pagination/Pagination";
import CustomButton, { ButtonFont, ButtonSize, ButtonType } from "../../../../../component/common/CustomButton/CustomButton";
import NudgeSponsoredUser from "../NudgeSponsoredUser/NudgeSponsoredUser";
import PromoteToSponsoredUser from "../PromoteToSponsoredUser/PromoteToSponsoredUser";
import SponsoredUserDetails from "../SponsoredUserDetails/SponsoredUserDetails";

type UserRow = {
  user: string;
  email: string;
  avatar: string | null;
  status: "Active" | "Inactive";
  promotedOn: string;
};

const SponseredUsersTable = () => {
    const [showNudgeSponsoredUser, setShowNudgeSponsoredUser] = useState<boolean>(false)
    const [showPromoteUserToSponsored, setShowPromoteUserToSponsored] = useState(false);
    const [showSponsoredUserDetails, setShowSponsoredUserDetails] = useState<boolean>(false);
    const data = useMemo<UserRow[]>(() => [
    {
        user: "Sarah Johnson",
        email: "sarah@example.com",
        avatar: "",
        status: "Active",
        promotedOn: "15/1/2024",
    },
    {
        user: "Mike Rodriguez",
        email: "mike@example.com",
        avatar: "",
        status: "Active",
        promotedOn: "20/2/2024",
    },
    {
        user: "Emma Chen",
        email: "emma@example.com",
        avatar: "",
        status: "Inactive",
        promotedOn: "10/3/2024",
    },
    ], []);

    const columns = useMemo<ColumnDef<UserRow>[]>(() => [
    {
        header: "User",
        accessorKey: "user",
        cell: (info) => {
        const row = info.row.original;
        return (
                <UserCard
                    userName={row.user}
                    userImage={row.avatar}
                />
            );
        },
    },
    {
        header: "Email",
        accessorKey: "email",
        cell: (info) => {
        const value = info.getValue<string>();
        return <div className='emaitableBox'>{value}</div>;
        },
    },
    {
        header: "Status",
        accessorKey: "status",
        cell: (info) => {
        const value = info.getValue<string>();
        return <span className={`statusBadge ${value.toLowerCase()}`}>{value}</span>;
        },
    },
    {
        header: "Promoted On",
        accessorKey: "promotedOn",
    },
    {
        header: "Action",
        accessorKey: "action",
        cell: () => (
        <ActionButtons
            editBtnImage={ASSESTS.MAILTAB}
            editBtnClick={() => setShowNudgeSponsoredUser(true)}
            viewBtnImage={ASSESTS.SEE}
            viewBtnClick={() => setShowSponsoredUserDetails(true)}
            showForwarBtn={true}
            forWardBtnImage={ASSESTS.PROMOTE}
            forWardBtnClick={() => setShowPromoteUserToSponsored(true)}
        />
        ),
        enableSorting: false,
    },
    ], []);

    const [sorting, setSorting] = useState<SortingState>([]);
    const [pageSize, setPageSize] = useState(5);
    const [rowSelection, setRowSelection] = useState<RowSelectionState>({});

    const table = useReactTable({
        data,
        columns,
        state: { sorting, rowSelection },
        onSortingChange: setSorting,
        onRowSelectionChange: setRowSelection,
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        enableRowSelection: true,
        initialState: { pagination: { pageIndex: 0, pageSize: pageSize } }
    });

    useEffect(() => {
        table.setPageSize(pageSize);
    }, [pageSize, table]);

    return (
        <>
            <div className={'tableContainer'}>
                <div className={"tableWrapper"}>
                    <table>
                        <thead>
                            {table.getHeaderGroups().map((headerGroup) => (
                                <tr key={headerGroup.id}>
                                    {headerGroup.headers.map((header) => {
                                        const isActionColumn = typeof header.column.columnDef.header === "string" && header.column.columnDef.header === "Action";
                                        return (
                                        <th
                                            key={header.id}
                                            onClick={header.column.getToggleSortingHandler()}
                                            style={{ 
                                                cursor: header.column.getCanSort() ? "pointer" : "default"
                                            }}
                                            className={cn(header.column.columnDef.id && `th-${header.column.columnDef.id}` , isActionColumn ? 'text-center' : undefined)}
                                        >
                                            {flexRender(header.column.columnDef.header, header.getContext())}
                                            {header.column.getCanSort() && 
                                                <span className={cn('tableShorting')}>
                                                    <Image 
                                                        src={header.column.getIsSorted() === "asc" ? ASSESTS.ASSENDING : header.column.getIsSorted() === "desc" ? ASSESTS.DECENDING : ASSESTS.SHORT} 
                                                        alt="Short" 
                                                    />
                                                </span>
                                            }
                                        </th>
                                        );
                                    })}
                                </tr>
                            ))}
                        </thead>
                        <tbody>
                            {table.getRowModel().rows.map((row) => (
                                <tr key={row.id}>
                                    {row.getVisibleCells().map((cell) => {
                                        const isActionColumn = typeof cell.column.columnDef.header === "string" && cell.column.columnDef.header === "Action";

                                        return (
                                        <td 
                                            key={cell.id} 
                                            className={cn(cell.column.columnDef.id && `td-${cell.column.columnDef.id}`, isActionColumn ? 'text-center' : undefined)}
                                        >
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                        </td>
                                    );
                                })}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <Pagination
                    enteriesShows={`${table.getState().pagination.pageIndex * pageSize + 1}-${Math.min((table.getState().pagination.pageIndex + 1) * pageSize, data.length )} of ${data.length} Entries`}
                    pageNumbers={Array.from({ length: table.getPageCount() }, (_, pageIndex) => (
                        <CustomButton
                            key={pageIndex}
                            onClick={() => table.setPageIndex(pageIndex)}
                            disabled={table.getState().pagination.pageIndex === pageIndex}
                            btnType={table.getState().pagination.pageIndex === pageIndex ? ButtonType.ACTIVENOSTYLE : ButtonType.NOSTYLE}
                            btnSize={ButtonSize.NORMAL}
                            btnFont={table.getState().pagination.pageIndex === pageIndex ? ButtonFont.BOLD : ButtonFont.NORMAL}
                            className={cn('pageNumberBtn', table.getState().pagination.pageIndex === pageIndex && 'activePageNumberBtn')}
                        >
                            {pageIndex + 1}
                        </CustomButton>
                    ))}
                    dropDownOptions={[
                        { value: "5", label: "5" },
                        { value: "10", label: "10" },
                        { value: "20", label: "20" },
                        { value: "25", label: "25" },
                    ]}
                    dropdownOnChange={(value) => { setPageSize(Number(value)); }}
                    dropDownPlaceholder={pageSize.toString()}
                />
            </div>
            <NudgeSponsoredUser 
                showModal={showNudgeSponsoredUser} 
                onClose={() => setShowNudgeSponsoredUser(false)} 
            />
            <PromoteToSponsoredUser 
                showModal={showPromoteUserToSponsored}
                onClose={() => setShowPromoteUserToSponsored(false)} 
            />
            <SponsoredUserDetails 
                showModal={showSponsoredUserDetails} 
                onClose={() => setShowSponsoredUserDetails(false)} 
            />
        </>
    );
};

export default SponseredUsersTable;
